
<ng-container *ngIf="ranges?.length">
    <div  [ngClass]="{'w-full invoice-ar-aging-button-custom': module ==='arAging'}">
    <button mat-stroked-button (click)="$event.stopPropagation();" id="date-range-button" [disabled]="isDisabled" [ngClass]="{'bg-gray-100': isDisabled,'w-full': module ==='arAging'}"
        class='inline-flex items-center mt-1.5 px-4 py-3 h-9 border border-gray-300 shadow-xs text-base font-medium rounded-md text-gray-700 bg-white'
        [matMenuTriggerFor]="menu">
        <span *ngIf="!showDate && module !== 'arAging'"> {{ selectedDateKey | translate }}
            <em *ngIf="isCloseVisible" (click)="resetDateRange();$event.stopPropagation();"
                class="ti ti-x hover:bg-gray-50 ml-2 p-1 rounded-full text-md font-semibold"></em>
            <em class="ti ti-chevron-down pl-2 text-base font-semibold"></em>
        </span>
        <span *ngIf="!showDate && module === 'arAging'" class="flex items-center justify-between w-full"> 
            <span>
            {{ selectedDateKey }}
            </span>
            <em *ngIf="isCloseVisible" (click)="resetDateRange();$event.stopPropagation();"
                class="ti ti-x hover:bg-gray-50 ml-2 p-1 rounded-full text-md font-semibold"></em>
            <em class="ti ti-chevron-down pl-2 text-base font-semibold"></em>
        </span>
        <div *ngIf="showDate">
            <div class="flex items-center">
        <span><em class="ti ti-calendar text-xl text-gray-700"></em></span>
        <span class="ml-2 text-gray-700"> {{ selectedDateKey }}</span>
        <span *ngIf="showDate && selectedRange.label !== 'CUSTOM_RANGE'" class="ml-2 text-gray-500"> {{selectedDateValue}}</span>
       <span><em *ngIf="isCloseVisible" (click)="resetDateRange();$event.stopPropagation();"
            class="ti ti-x hover:bg-gray-50 ml-2 p-1 rounded-full text-md font-semibold"></em>
        <em class="ti ti-chevron-down pl-2 text-base font-semibold"></em>
    </span>
    </div>
    </div>
        <mat-form-field appearance="fill" class="datepicker-calendar-icon invisible w-0">
            <mat-date-range-input [rangePicker]="picker">
                <input matStartDate placeholder="Start date" [(ngModel)]="selected.startDate">
                <input matEndDate placeholder="End date" [(ngModel)]="selected.endDate"
                    (dateChange)="datesUpdated($event)">
            </mat-date-range-input>
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-date-range-picker #picker></mat-date-range-picker>
        </mat-form-field>
    </button>
    </div>
    <mat-menu #menu="matMenu" [class]="showDate ? 'custom-menu' : '' ">
        <ng-container *ngFor='let range of ranges'>
            <div class="text-gray-700 block px-4 py-2 text-base date-range-picker" (click)="updateDate(range)"
                mat-menu-item>
                <div class="flex justify-between w-full">
                    <span>{{range?.key}}</span>
                    <span class="text-sm text-gray-500" *ngIf="showDate && (range?.rangeKey === 'TODAY' || range?.rangeKey === 'YESTERDAY')">
                        {{ range?.value[0] | date: 'dd MMM yyyy' }}
                      </span>
                      
                      <span class="text-sm text-gray-500" *ngIf="showDate && (range?.rangeKey !== 'TODAY' && range?.rangeKey !== 'YESTERDAY')">
                        <ng-container *ngIf="(range?.value[0] | date: 'yyyy') === (range?.value[1] | date: 'yyyy'); else differentYears">
                          {{ range?.value[0] | date: 'dd MMM' }} - {{ range?.value[1] | date: 'dd MMM yyyy' }}
                        </ng-container>
                        <ng-template #differentYears>
                          {{ range?.value[0] | date: 'dd MMM yyyy' }} - {{ range?.value[1] | date: 'dd MMM yyyy' }}
                        </ng-template>
                      </span>
                    </div>
                </div>
                <hr *ngIf="showDate && (range.rangeKey === 'PROJECT_TIMELINE' || range.rangeKey === 'LAST_MONTH')" />
        </ng-container>
        <a *ngIf="!showDate" (click)="openDateRangePicker()" class="text-gray-700 block px-4 py-2 text-base date-range-picker" mat-menu-item>{{'text.custom_range' | translate}}</a>
        <div *ngIf="showDate"(click)="openDateRangePicker()" mat-menu-item>
            <div class="flex items-center justify-between w-full">
                <a class="text-gray-700 block py-2 text-base date-range-picker">{{'text.custom_range' | translate}}</a>
                <em class="ti ti-chevron-right text-gray-400 text-xl px-4 py-2"></em>
            </div>
        </div>
    </mat-menu>
</ng-container>